import { rememberMinimalStyle } from '@utils/minimalStyle';
import { createContext, ReactNode, useContext, useEffect } from 'react';

const MinimalStyleContext = createContext(false);

export function MinimalStyleProvider({
  isMinimalStyle,
  children,
}: {
  isMinimalStyle: boolean;
  children: ReactNode;
}) {
  useEffect(() => {
    rememberMinimalStyle(isMinimalStyle);
  }, [isMinimalStyle]);

  return (
    <MinimalStyleContext.Provider value={isMinimalStyle}>{children}</MinimalStyleContext.Provider>
  );
}

export const useIsMinimalStyle = (): boolean => useContext(MinimalStyleContext);
